export async function launchPortalPreview(input: {
	previewOrigin: string;
	exchangeCode: string;
	previewId: string;
	openWindow?: (url: string, target?: string) => Window | null;
}) {
	const opener = (input.openWindow ?? window.open)(
		`${input.previewOrigin}/preview-launch.html`,
		`preview-${input.previewId}`,
	);
	if (!opener) throw new Error("Preview window could not be opened");
	const onMessage = (event: MessageEvent) => {
		if (event.origin !== input.previewOrigin || event.source !== opener || event.data?.type !== "portalPreviewReady")
			return;
		opener.postMessage(
			{ type: "portalPreviewExchange", exchangeCode: input.exchangeCode, previewId: input.previewId },
			input.previewOrigin,
		);
		window.removeEventListener("message", onMessage);
	};
	window.addEventListener("message", onMessage);
}
export function installPreviewLauncher(portalOrigin: string) {
	if (!window.opener) return;
	window.opener.postMessage({ type: "portalPreviewReady" }, portalOrigin);
	window.addEventListener(
		"message",
		async (event) => {
			if (
				event.origin !== portalOrigin ||
				event.source !== window.opener ||
				event.data?.type !== "portalPreviewExchange"
			)
				return;
			const response = await fetch("/api/portal/v1/preview-session", {
				method: "POST",
				credentials: "include",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ exchangeCode: event.data.exchangeCode }),
			});
			const previewId = event.data.previewId;
			if (response.ok && typeof previewId === "string" && /^[0-9a-f-]{36}$/i.test(previewId))
				location.replace(`/api/portal/v1/preview/${previewId}/`);
		},
		{ once: true },
	);
}

if (typeof window !== "undefined" && window.opener) {
	try {
		const configuredOrigin = document
			.querySelector<HTMLMetaElement>('meta[name="substrate-portal-origin"]')
			?.content.trim();
		if (!configuredOrigin || new URL(configuredOrigin).origin !== configuredOrigin)
			throw new Error("Preview launcher origin is not configured");
		installPreviewLauncher(configuredOrigin);
	} catch {
		document.getElementById("status")?.replaceChildren("The private preview session could not be established.");
	}
}
